import React, { useEffect, useContext, useState } from "react";
import { ChevronFirst, AlignLeft, Settings } from "lucide-react";
import { sidebarContext } from "../pages/StudentLayout";
import axios from "axios";
import { useNavigate } from "react-router-dom";


export default function AppBar() {
  const { expanded, setExpanded, setIsMobile } = useContext(sidebarContext);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setExpanded(false);
        setIsMobile(true);
      } else if (window.innerWidth <= 1024) {
        setExpanded(false);
        setIsMobile(false);
      } else {
        setExpanded(true);
        setIsMobile(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [setExpanded, setIsMobile]);

  const [isHovered, setIsHovered] = useState(false); // State to track hover

  const [menuOpen, setMenuOpen] = useState(false); // State to track menu open

  return (
    <div className="relative flex h-16">
      <div className="fixed top-0 left-0 w-full bg-white h-16 flex items-center shadow-md px-4 z-10">

        <button
          className="p-1.5 rounded-lg mr-4"
          onClick={() => setExpanded((curr) => !curr)}
          style={{
            backgroundColor: isHovered ? '#6d28d9' : '#904dd3', // Change color on hover
            color: "white"
          }}
          onMouseEnter={() => setIsHovered(true)}  // Set hover state on enter
          onMouseLeave={() => setIsHovered(false)} // Unset hover state on leave
        >
          {expanded ? <ChevronFirst /> : <AlignLeft />}
        </button>

        <img
          src="https://img.logoipsum.com/243.svg"
          className="w-10 h-10 mr-4"
          alt="App Logo"
        />

        <h1 className="flex-grow text-gray-600 text-lg">CMS</h1>

        <div className="relative">
          <button
            className="focus:outline-none"
            onClick={() => setMenuOpen((curr) => !curr)}
          >
            <Settings style={{ color: "#904dd3" }} />
          </button>
          {menuOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg">
              <button
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
                onClick={async () => {
                  setMenuOpen(false);
                  localStorage.clear();
                  sessionStorage.clear();
                  const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/logout`);
                  if (res.status === 200) {
                    navigate("/");
                  }
                }}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
